import { NgModule } from '@angular/core';
import { MainItemComponent } from './main-item.component';
import { ConcertMainModule } from '../concert/concert-main/concert-main.module';
import { TicketMainModule } from '../ticket/ticket-main/ticket-main.module';
import { ImportModule } from 'src/app/import.module';
import { RouterModule, Routes } from '@angular/router';

@NgModule({
  imports: [ImportModule, ConcertMainModule, TicketMainModule],
  declarations: [MainItemComponent],
})
export class MainItemModule {}
